import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import RouteTransition from "@/components/RouteTransition";
import HomePage from "@/pages/HomePage";
import ServicosPage from "@/pages/ServicosPage";
import PneusPage from "@/pages/PneusPage";
import SobrePage from "@/pages/SobrePage";
import OrcamentoPage from "@/pages/OrcamentoPage";
import FAQPage from "@/pages/FAQPage";
import SimuladorPage from "@/pages/SimuladorPage";
import GuiasPage from "@/pages/GuiasPage";
import LoginPage from "@/pages/LoginPage";
import MinhaContaPage from "@/pages/MinhaContaPage";
import OsMeusOrcamentosPage from "@/pages/OsMeusOrcamentosPage";
import AdminPage from "@/pages/AdminPage";
import AuthCallback from "@/pages/AuthCallback";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import { AuthProvider } from "@/lib/AuthContext";

const TOASTER_OPTIONS = {
  style: {
    background: "#163A6D",
    border: "1px solid #2F568F",
    color: "#FFFFFF",
    borderRadius: 0,
  },
};

// Detect the OAuth callback `#session_id=` in the URL *during render* to avoid
// race conditions with the AuthProvider's /me check.
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/servicos" element={<ServicosPage />} />
        <Route path="/precario" element={<ServicosPage />} />
        <Route path="/pneus" element={<PneusPage />} />
        <Route path="/sobre" element={<SobrePage />} />
        <Route path="/orcamento" element={<OrcamentoPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/simulador" element={<SimuladorPage />} />
        <Route path="/guias" element={<GuiasPage />} />
        <Route path="/guias/:slug" element={<GuiasPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/minha-conta" element={<MinhaContaPage />} />
        <Route path="/os-meus-orcamentos" element={<OsMeusOrcamentosPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <RouteTransition />
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={TOASTER_OPTIONS}
      />
    </div>
  );
}

export default App;
